import dynaForms from '@elab/core/utils/dynaForms';

import { storeName } from './types';

const getStore = state => state[storeName] || {};
const getPreferenceGroups = state => getStore(state).preferenceGroups || [];
const getPreferences = state => getStore(state).preferences || {};
const getOtherGroup = state => getStore(state).otherGroup || {};
const getConsentTemplates = state => getStore(state).consentTemplates || [];
const getCurrentSelection = state => getStore(state).currentSelection || {};

export default {
    ...dynaForms.getSelectors(storeName),
    getPreferenceGroups,
    getPreferences,
    getOtherGroup,
    getConsentTemplates,
    getCurrentSelection,
};
